import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, overline, title, desc, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      {index && <span className="font-mono text-xs text-[#0055FF] tracking-widest">{index}</span>}
      <span className="h-px w-10 bg-[#0055FF]" />
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#647087]">{overline}</span>
    </div>
    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter text-white mt-6 leading-[0.95]">
      {title}
    </h2>
    {desc && <p className="text-base md:text-lg text-[#A0AABF] mt-6 max-w-2xl leading-relaxed">{desc}</p>}
  </Reveal>
);
